module.exports = __webpack_public_path__ + "img/album10_05.322bc1fc.jpg";